var styles = {"root":"Month_root__1f9k1","even":"Month_even__2e0iu","row":"Month_row__3-dFQ","odd":"Month_odd__2rBip","rows":"Month_rows__2Ua4M","partial":"Month_partial__8DLi9","label":"Month_label__3pTPM","partialFirstRow":"Month_partialFirstRow__3liz2"};

export default styles;
